export const RegisterContent = () => {
  return (
    <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
      <div className="flex flex-col space-y-2 text-center">
        <h1 className="text-2xl font-semibold tracking-tight">
          Welcome to our platform
        </h1>
        <p className="text-sm text-muted-foreground">
          Register to access all features
        </p>
      </div>
    </div>
  );
};